import { setCookie } from "@/hooks/cookie-helper";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { companyApi } from "./company-apis";
import { companyInviteApi } from "./company-invite-apis";

export const PERSISTED_CURRENT_COMPANY_KEY = "nttp_companyId";

interface CompanyState {
  isOnboarding: boolean;
  onboardingFormKey: OnboardingFormKeys | null;
  companies: CompanyUser[];
  currentCompany: CompanyUser | null;
  myInvites: CompanyInvite[];
}

const initialState: CompanyState = {
  isOnboarding: false,
  onboardingFormKey: "company_onboarding",
  companies: [],
  myInvites: [],
  currentCompany: null,
};

export const setCurrentCompanyCookie = (systemRef: string) => {
  setCookie({
    name: PERSISTED_CURRENT_COMPANY_KEY,
    value: systemRef,
    days: 3556,
  });
};

const CompanySlice = createSlice({
  name: "companySlice",
  initialState,
  reducers: {
    setOnboarding: (state, action: PayloadAction<boolean>) => {
      state.isOnboarding = action.payload;
      if (action.payload) {
        state.isOnboarding = false;
        state.onboardingFormKey = null;
      }
    },
    setInvites: (state, action: PayloadAction<CompanyInvite[]>) => {
      state.myInvites = action.payload;
    },
    setOnboardingFormKey: (
      state,
      action: PayloadAction<OnboardingFormKeys | null>
    ) => {
      state.onboardingFormKey = action.payload;
      state.isOnboarding = action.payload ? true : false;
    },
    setCompanyUsers: (state, action: PayloadAction<CompanyUser[]>) => {
      state.companies = action.payload;
    },

    setCurrentCompany: (state, action: PayloadAction<CompanyUser>) => {
      state.currentCompany = action.payload;
      const isServerSide = typeof document === "undefined";
      if (
        !isServerSide &&
        state.currentCompany &&
        state.currentCompany.systemRef
      )
        setCurrentCompanyCookie(state.currentCompany.systemRef);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      companyApi.endpoints.loadCompanies.matchFulfilled,
      (state, action) => {
        state.companies = action.payload;
      }
    );
    builder.addMatcher(
      companyInviteApi.endpoints.updateInviteStatus.matchFulfilled,
      (state, action) => {
        state.myInvites = state.myInvites.filter(
          (i) => i.id !== action.payload.id
        );
      }
    );
  },
});

export const companyActions = CompanySlice.actions;
export default CompanySlice.reducer;
